// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-cardselect-field',
    // #endregion
    // #region Mixins
    mixins: [appHost.mixins.form],
    // #endregion
    // #region Props
    props: {
        inputAttr: {
            type: Object,
            required: false,
            default: null,
        },
        items: {
            type: Array,
            required: false
        },
        showLabel: {
            type: Boolean,
            required: false,
            default: true
        },
    },
    // #endregion
    // #region Data
    data: () => ({}),
    // #endregion
    // #region Computed
    computed: {
        inputAttrInternal() {
            return this.inputAttr;
        },
    },
    // #endregion
    // #region Methods
    methods: {}
    // #endregion
});
// #endregion
